module.exports = __webpack_public_path__ + "img/main.0f2c7d1d.jpg";